import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import {
  LocaleSelector,
  useLanguageLabel,
} from "@redotech/redo-i18n/locale-selector";
import { localizationConfig } from "@redotech/redo-i18n/localization-config";
import { RedoMerchantClientContext } from "@redotech/redo-merchant-app-common/client/context";
import { updateUserLocale } from "@redotech/redo-merchant-app-common/client/user";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import { localizationEnabled } from "@redotech/redo-team-common/localization/settings";
import { memo, useContext, useSyncExternalStore } from "react";

export function useMerchantLocaleSelectorVisible(): boolean {
  const team = useContext(TeamContext);
  const configEnabled = useSyncExternalStore(
    localizationConfig.subscribe,
    localizationConfig.isEnabled,
  );
  return localizationEnabled(team?.settings.localization) && configEnabled;
}

export function useMerchantLanguageLabel(): string {
  return useLanguageLabel();
}

export const MerchantLocaleSelector = memo(function MerchantLocaleSelector({
  onOpenChange,
  open,
}: {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}) {
  const team = useContext(TeamContext);
  const user = useRequiredContext(UserContext);
  const client = useRequiredContext(RedoMerchantClientContext);
  const handleLocaleChange = useHandler((locale: string) => {
    void updateUserLocale(client, { userId: user._id, locale });
  });

  if (!localizationEnabled(team?.settings.localization)) {
    return null;
  }

  return (
    <LocaleSelector
      onLocaleChange={handleLocaleChange}
      onOpenChange={onOpenChange}
      open={open}
    />
  );
});
